/**
 * Small registry mapping appId → live `AppEmbed` handle.
 *
 * `AppMountedRoute` owns the ref to each mounted app's iframe; the host
 * NotificationBell (rendered in the site header, far from the mount route)
 * needs to dispatch `rumio:notification-action` clicks back to the right
 * iframe. A module-level map is the lightest way to bridge the two without
 * stuffing imperative refs into a Zustand store.
 *
 * Only one iframe is active per appId at a time (mounts are unique by
 * `path_prefix`, which is unique per app installation).
 */
import type { AppEmbedHandle } from '@/components/AppEmbed';

const handles = new Map<string, AppEmbedHandle>();

export function setEmbedHandle(appId: string, handle: AppEmbedHandle | null): void {
  if (handle === null) {
    handles.delete(appId);
    return;
  }
  handles.set(appId, handle);
}

export function clearEmbedHandle(appId: string): void {
  handles.delete(appId);
}

export function getEmbedHandle(appId: string): AppEmbedHandle | undefined {
  return handles.get(appId);
}
